module.exports = function themeConfig (options) {
  const theme  = Object(options).theme || {}
  const border = theme.border || {}

  const colors = Object.assign({
    'transparent':   'transparent',

    'black':         '#292929',
    'white':         '#ffffff',

    'grey-darkest':  '#484848',
    'grey-darker':   '#6e6e6e',
    'grey-dark':     '#949494',
    'grey':          '#c2c2c2',
    'grey-light':    '#e1e1e1',
    'grey-lighter':  '#f5f5f5',
    'grey-lightest': '#fafafa',

    'primary':       '#3490dc',
    'success':       '#38c172',
    'warning':       '#f6993f',
    'danger':        '#e3342f',
    'info':          '#8795a1'
  }, theme.colors)

  const fonts = theme.fonts || {
    'sans':  ['Roboto', 'Arial', 'sans-serif'],
    'serif': ['Roboto Slab', 'Georgia', 'serif'],
    'mono':  ['Roboto Mono', 'Verdana', 'monospace']
  }

  const spacing = Object.assign({
    '0':   '0rem',
    '2xs': '0.25rem',
    'xs':  '0.5rem',
    'sm':  '1rem',
    'md':  '1.5rem',
    'lg':  '2rem',
    'xl':  '3rem',
    '2xl': '4rem',
    '3xl': '5rem',
    '4xl': '6rem',
    '5xl': '8rem'
  }, theme.spacing)

  const sizing = Object.assign({
    '2xs': '0.5rem',
    'xs':  '1rem',
    'sm':  '2rem',
    'md':  '4rem',
    'lg':  '6rem',
    'xl':  '8rem',
    '2xl': '10rem',
    '3xl': '16rem',
    '4xl': '20rem',
    '5xl': '24rem',
    '6xl': '30rem',
    '7xl': '40rem',
    '8xl': '50rem',
    '9xl': '60rem'
  }, theme.sizing)

  const radius = {
    'none':    '0',
    'sm':      '0.125rem',
    'default': '0.25rem',
    'lg':      '0.5rem',
    'full':    '9999px'
  }

  const borders = {
    'default': '1px',
    '0':       '0',
    '2':       '2px',
    '4':       '4px',
    '8':       '8px'
  }

  return {
    colors: colors,
    screens: {
      'sm': '576px',
      'md': '768px',
      'lg': '992px',
      'xl': '1200px'
    },
    fonts: fonts,
    textSizes: {
      'xs':  '0.75rem',
      'sm':  '0.875rem',
      'md':  '1rem',
      'lg':  '1.125rem',
      'xl':  '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem'
    },
    fontWeights: {
      'hairline':  100,
      'thin':      200,
      'light':     300,
      'normal':    400,
      'medium':    500,
      'semibold':  600,
      'bold':      700,
      'extrabold': 800,
      'black':     900
    },
    leading: {
      'xs': 1,
      'sm': 1.25,
      'md': 1.5,
      'lg': 1.75,
      'xl': 2
    },
    tracking: {
      'tight':  '-0.05em',
      'normal': '0',
      'wide':   '0.05em'
    },
    textColors: colors,
    backgroundColors: colors,
    backgroundSize: {
      'auto':    'auto',
      'cover':   'cover',
      'contain': 'contain'
    },
    borderWidths: borders,
    borderColors: Object.assign({ 'default': colors['grey-light'] }, colors),
    borderRadius: Object.assign({}, radius, { default: (radius[border.radius] || radius.default) }),
    width: Object.assign({
      'auto':   'auto',
      '0':      '0',
      '1/2':    '50%',
      '1/3':    '33.33333%',
      '2/3':    '66.66667%',
      '1/4':    '25%',
      '3/4':    '75%',
      '1/5':    '20%',
      '2/5':    '40%',
      '3/5':    '60%',
      '4/5':    '80%',
      '1/6':    '16.66667%',
      '5/6':    '83.33333%',
      'full':   '100%',
      'screen': '100vw',
      'max':    'max-content',
      'min':    'min-content'
    }, sizing),
    height: Object.assign({
      'auto':   'auto',
      '0':      '0',
      'full':   '100%',
      'screen': '100vh'
    }, sizing),
    minWidth: {
      'auto':   'auto',
      '0':      '0',
      'full':   '100%',
      'screen': '100vw'
    },
    minHeight: {
      'auto':   'auto',
      '0':      '0',
      'full':   '100%',
      'screen': '100vh'
    },
    maxWidth: {
      'auto':   'auto',
      '0':      '0',
      'full':   '100%',
      'screen': '100vw'
    },
    maxHeight: {
      'auto':   'auto',
      '0':      '0',
      'full':   '100%',
      'screen': '100vh'
    },
    padding: spacing,
    margin: Object.assign({ 'auto': 'auto' }, spacing),
    negativeMargin: Object.assign({ '1': '1px' }, spacing),
    shadows: {
      'default': '0 2px 4px 0 rgba(0,0,0,0.10)',
      'md':      '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
      'lg':      '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
      'inner':   'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
      'outline': '0 0 0 3px rgba(52,144,220,0.5)',
      'none':    'none'
    },
    zIndex: {
      'auto': 'auto',
      '0':    0,
      '10':   10,
      '20':   20,
      '30':   30,
      '40':   40,
      '50':   50
    },
    opacity: {
      '0':   '0',
      '25':  '0.25',
      '50':  '0.5',
      '75':  '0.75',
      '100': '1'
    },
    svgFill: {
      'current': 'currentColor'
    },
    svgStroke: {
      'current': 'currentColor'
    },
    ratios: {
      'false':  [0, 0],
      'square': [1, 1],
      '4/3':    [4, 3],
      '16/9':   [16, 9],
      '21/9':   [21, 9],
      '3/4':    [3, 4]
    },
    gridColumns: ['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    gridGaps: Object.assign({}, borders, spacing),
    gridWidths: sizing,
    modules: {
      appearance:           ['responsive'],
      backgroundAttachment: ['responsive'],
      backgroundColors:     ['responsive', 'hover', 'focus'],
      backgroundPosition:   ['responsive'],
      backgroundRepeat:     ['responsive'],
      backgroundSize:       ['responsive'],
      borderCollapse:       ['responsive'],
      borderColors:         ['responsive', 'hover', 'focus'],
      borderRadius:         ['responsive'],
      borderStyle:          ['responsive'],
      borderWidths:         ['responsive'],
      cursor:               ['responsive'],
      display:              ['responsive'],
      flexbox:              ['responsive'],
      float:                ['responsive'],
      fonts:                ['responsive'],
      fontWeights:          ['responsive', 'hover', 'focus'],
      height:               ['responsive'],
      leading:              ['responsive'],
      lists:                ['responsive'],
      margin:               ['responsive'],
      maxHeight:            ['responsive'],
      maxWidth:             ['responsive'],
      minHeight:            ['responsive'],
      minWidth:             ['responsive'],
      negativeMargin:       ['responsive'],
      objectFit:            ['responsive'],
      objectPosition:       ['responsive'],
      opacity:              ['responsive', 'hover', 'focus'],
      outline:              ['focus'],
      overflow:             ['responsive'],
      padding:              ['responsive'],
      pointerEvents:        ['responsive'],
      position:             ['responsive'],
      resize:               ['responsive'],
      shadows:              ['responsive', 'hover', 'focus'],
      svgFill:              ['responsive', 'hover', 'focus'],
      svgStroke:            ['responsive', 'hover', 'focus'],
      tableLayout:          ['responsive'],
      textAlign:            ['responsive'],
      textColors:           ['responsive', 'hover', 'focus'],
      textSizes:            ['responsive'],
      textStyle:            ['responsive', 'hover', 'focus'],
      tracking:             ['responsive'],
      userSelect:           ['responsive'],
      verticalAlign:        ['responsive'],
      visibility:           ['responsive'],
      whitespace:           ['responsive'],
      width:                ['responsive'],
      zIndex:               ['responsive'],
      container:            ['responsive'],
      ratio:                ['responsive'],
      grid:                 ['responsive'],
      flexGrid:             ['responsive'],
      stack:                ['responsive']
    },
    options: {
      prefix:    '',
      important: false,
      separator: ':'
    }
  }
}
